"use client";

import { useEffect } from "react";

/**
 * Listener global de `Cmd+Shift+T` (Mac) o `Ctrl+Shift+T` (Windows/Linux)
 * para alternar tema claro/oscuro. Persiste en localStorage.
 */
export function useThemeToggleShortcut() {
  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      const isMac = typeof navigator !== "undefined" && /Mac|iPhone|iPad/.test(navigator.platform);
      const mod = isMac ? e.metaKey : e.ctrlKey;
      if (mod && e.shiftKey && e.key.toLowerCase() === "t") {
        // Ignorar si el command palette ya maneja esto (pero no estorba)
        e.preventDefault();
        const isDark = document.documentElement.classList.toggle("dark");
        localStorage.setItem("wiki_theme", isDark ? "dark" : "light");
      }
    };
    document.addEventListener("keydown", handler);
    return () => document.removeEventListener("keydown", handler);
  }, []);
}
